@if (userList?.length > 10 || userNextCursor) {
  <div class="user-suggestion-width mb-2">
    <gtapp-auto-complete
      class="w-100"
      [data]="userSearchList"
      placeHolder="Search User"
      searchKeyword="full_name"
      [itemTemplate]="assigneeListTemplate"
      (inputChanged)="searchAssignee($event)"
      (selected)="onSelectUser.emit($event)"
    >
    </gtapp-auto-complete>
    <ng-template #assigneeListTemplate let-item>
      <div class="d-flex gap-2 flex-wrap">
        <span>
          {{ item?.full_name }}
        </span>
        @if (item?.access_status === 2) {
          <div
            class="text-warning-emphasis small-font bg-white rounded my-auto border px-2 fw-semibold"
          >
            Casual
          </div>
        }
      </div>
    </ng-template>
  </div>
}

<div id="assigneeList" class="overflow-45vh">
  <div class="d-flex flex-wrap row-gap-2 column-gap-4">
    @for (assignee of userList; track $index) {
      <div
        (click)="onSelectUser.emit(assignee)"
        role="button"
        class="p-2 py-3 py-lg-2 border rounded bg-secondary-subtle text-dark pe-4 user-suggestion-width d-flex gap-2 align-items-center flex-grow-sm-1"
        [ngClass]="assignee?.selected ? 'fw-semibold' : 'opacity-75'"
      >
        <input type="checkbox" [checked]="assignee?.selected" />
        <span>
          {{ assignee?.full_name }}
        </span>

        @if (assignee?.access_status === 2) {
          <div
            class="text-warning-emphasis small-font bg-white rounded my-auto border px-2 fw-semibold"
          >
            Casual
          </div>
        }
      </div>
    }
    @if (userNextCursor) {
      <button
        type="button"
        class="btn btn-secondary btn-md user-suggestion-width"
        (click)="getUsers()"
      >
        Load More
      </button>
    }
  </div>
</div>
